//import router from 'router';
"use strict";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _common = require("common");

var _common2 = _interopRequireDefault(_common);

// Store the root of your application, used for routing
window._ROOT = window.WEB_ROOT.slice(0, -1);

// Start router
//router.init(_ROOT);

// Global stuff (not module-dependant, preloading, etc)
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9iYWJlL1dvcmsvdjIuZG91YmxlZy51bHRyYW5vaXIuY29tL2Fzc2V0cy9zY3JpcHRzL2FwcC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztzQkFDbUIsUUFBUTs7Ozs7QUFFM0IsTUFBTSxDQUFDLEtBQUssR0FBRyxNQUFNLENBQUMsUUFBUSxDQUFDLEtBQUssQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsQ0FBQyIsImZpbGUiOiIvVXNlcnMvYmFiZS9Xb3JrL3YyLmRvdWJsZWcudWx0cmFub2lyLmNvbS9hc3NldHMvc2NyaXB0cy9hcHAuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvL2ltcG9ydCByb3V0ZXIgZnJvbSAncm91dGVyJztcbmltcG9ydCBjb21tb24gZnJvbSBcImNvbW1vblwiO1xuLy8gU3RvcmUgdGhlIHJvb3Qgb2YgeW91ciBhcHBsaWNhdGlvbiwgdXNlZCBmb3Igcm91dGluZ1xud2luZG93Ll9ST09UID0gd2luZG93LldFQl9ST09ULnNsaWNlKDAsIC0xKTtcblxuLy8gU3RhcnQgcm91dGVyXG4vL3JvdXRlci5pbml0KF9ST09UKTtcblxuLy8gR2xvYmFsIHN0dWZmIChub3QgbW9kdWxlLWRlcGVuZGFudCwgcHJlbG9hZGluZywgZXRjKSJdfQ==